import { useEffect, useRef } from 'react';
import { useReactiveVar } from '@apollo/client';
import { restClient } from '@/config/rest-client';
import { logError } from '@/utils/log-error';
import { csrfTokenVar } from '@/config/csrfTokenVar';

export function useNewCSRFToken() {
  const csrfToken = useReactiveVar(csrfTokenVar);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    if (isFetchingRef.current || csrfToken) return;

    isFetchingRef.current = true;

    (async () => {
      try {
        const { data } = await restClient().get<{ csrf_token: string }>(
          '/api/v1/new_csrf_token'
        );
        csrfTokenVar(data.csrf_token);
      } catch (error) {
        logError(`[useNewCSRFToken error]: ${JSON.stringify(error)}`);
      } finally {
        isFetchingRef.current = false;
      }
    })();
  }, [csrfToken]);

  return csrfToken;
}
